// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client'
import type {
  CreateUserPlanPlanCreateLessonIdGetData,
  CreateUserPlanPlanCreateLessonIdGetResponses,
  CreateUserPlanPlanCreateLessonIdGetErrors,
  ValidateUserPlanPlanValidatePostData,
  ValidateUserPlanPlanValidatePostResponses,
  ValidateUserPlanPlanValidatePostErrors,
  UpdateUserPlanSectionPlanSubmitSectionPostData,
  UpdateUserPlanSectionPlanSubmitSectionPostResponses,
  UpdateUserPlanSectionPlanSubmitSectionPostErrors,
  GetUserPlanPlanAllUserPlansGetData,
  GetUserPlanPlanAllUserPlansGetResponses,
  UpdateUserPlanPlanUpdatePostData,
  UpdateUserPlanPlanUpdatePostResponses,
  UpdateUserPlanPlanUpdatePostErrors,
  GetGradesListGradePostData,
  GetGradesListGradePostResponses,
  GetSubjectsListGradeSubjectPostData,
  GetSubjectsListGradeSubjectPostResponses,
  GetSubjectsListGradeSubjectPostErrors,
  GetLessonListLessonLessonIdGetData,
  GetLessonListLessonLessonIdGetResponses,
  GetLessonListLessonLessonIdGetErrors,
  GetLessonsListGradeSubjectLessonsPostData,
  GetLessonsListGradeSubjectLessonsPostResponses,
  GetLessonsListGradeSubjectLessonsPostErrors,
  GetGuidanceListGuidancePostData,
  GetGuidanceListGuidancePostResponses,
  SigninAuthSigninPostData,
  SigninAuthSigninPostResponses,
  SigninAuthSigninPostErrors,
  ForgotPasswordAuthForgotPasswordPostData,
  ForgotPasswordAuthForgotPasswordPostResponses,
  ForgotPasswordAuthForgotPasswordPostErrors,
  ChangePasswordAuthChangePasswordPostData,
  ChangePasswordAuthChangePasswordPostResponses,
  ChangePasswordAuthChangePasswordPostErrors,
  NewUserChangePasswordAuthNewUserChangePasswordPostData,
  NewUserChangePasswordAuthNewUserChangePasswordPostResponses,
  NewUserChangePasswordAuthNewUserChangePasswordPostErrors,
  NewAccessTokenAuthNewTokenPostData,
  NewAccessTokenAuthNewTokenPostResponses,
  NewAccessTokenAuthNewTokenPostErrors,
  LogoutAuthLogoutPostData,
  LogoutAuthLogoutPostResponses,
  CreateLessonSetupLessonPostData,
  CreateLessonSetupLessonPostResponses,
  CreateLessonSetupLessonPostErrors,
  CreateInitialLessonPlanSetupLessonPlanPostData,
  CreateInitialLessonPlanSetupLessonPlanPostResponses,
  CreateInitialLessonPlanSetupLessonPlanPostErrors,
  CreateGuidanceSetupGuidancePostData,
  CreateGuidanceSetupGuidancePostResponses,
  CreateGuidanceSetupGuidancePostErrors,
  DeleteUserLessonPlanDeleteUserLessonPlanPostData,
  DeleteUserLessonPlanDeleteUserLessonPlanPostResponses,
  DeleteUserLessonPlanDeleteUserLessonPlanPostErrors,
  DeleteLessonDeleteLessonPostData,
  DeleteLessonDeleteLessonPostResponses,
  DeleteLessonDeleteLessonPostErrors,
  DeleteGuidanceDeleteGuidancePostData,
  DeleteGuidanceDeleteGuidancePostResponses,
  DeleteGuidanceDeleteGuidancePostErrors,
  DeleteAllGuidanceDeleteAllGuidancePostData,
  DeleteAllGuidanceDeleteAllGuidancePostResponses,
  AskQuestionChatbotAskPostData,
  AskQuestionChatbotAskPostResponses,
  AskQuestionChatbotAskPostErrors,
  RootGetData,
  RootGetResponses,
  HealthHealthGetData,
  HealthHealthGetResponses,
  HelloWorldHelloWorldGetData,
  HelloWorldHelloWorldGetResponses,
} from './types.gen'
import { client as _heyApiClient } from './client.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * Create User Plan
 */
export const createUserPlanPlanCreateLessonIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateUserPlanPlanCreateLessonIdGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    CreateUserPlanPlanCreateLessonIdGetResponses,
    CreateUserPlanPlanCreateLessonIdGetErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/plan/create/{lesson_id}',
    ...options,
  })
}

/**
 * Validate User Plan
 */
export const validateUserPlanPlanValidatePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ValidateUserPlanPlanValidatePostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ValidateUserPlanPlanValidatePostResponses,
    ValidateUserPlanPlanValidatePostErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/plan/validate',
    ...options,
  })
}

/**
 * Update User Plan Section
 */
export const updateUserPlanSectionPlanSubmitSectionPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateUserPlanSectionPlanSubmitSectionPostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    UpdateUserPlanSectionPlanSubmitSectionPostResponses,
    UpdateUserPlanSectionPlanSubmitSectionPostErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/plan/submit-section',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get User Plan
 */
export const getUserPlanPlanAllUserPlansGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetUserPlanPlanAllUserPlansGetData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUserPlanPlanAllUserPlansGetResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/plan/all-user-plans',
    ...options,
  })
}

/**
 * Update User Plan
 */
export const updateUserPlanPlanUpdatePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateUserPlanPlanUpdatePostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    UpdateUserPlanPlanUpdatePostResponses,
    UpdateUserPlanPlanUpdatePostErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/plan/update',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Grades
 */
export const getGradesListGradePost = <ThrowOnError extends boolean = false>(
  options?: Options<GetGradesListGradePostData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    GetGradesListGradePostResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/list/grade',
    ...options,
  })
}

/**
 * Get Subjects
 */
export const getSubjectsListGradeSubjectPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetSubjectsListGradeSubjectPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GetSubjectsListGradeSubjectPostResponses,
    GetSubjectsListGradeSubjectPostErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/list/{grade}/subject',
    ...options,
  })
}

/**
 * Get Lesson
 */
export const getLessonListLessonLessonIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetLessonListLessonLessonIdGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetLessonListLessonLessonIdGetResponses,
    GetLessonListLessonLessonIdGetErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/list/lesson/{lesson_id}',
    ...options,
  })
}

/**
 * Get Lessons
 */
export const getLessonsListGradeSubjectLessonsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetLessonsListGradeSubjectLessonsPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GetLessonsListGradeSubjectLessonsPostResponses,
    GetLessonsListGradeSubjectLessonsPostErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/list/{grade}/{subject}/lessons',
    ...options,
  })
}

/**
 * Get Guidance
 */
export const getGuidanceListGuidancePost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetGuidanceListGuidancePostData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    GetGuidanceListGuidancePostResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/list/guidance',
    ...options,
  })
}

/**
 * Signin
 */
export const signinAuthSigninPost = <ThrowOnError extends boolean = false>(
  options: Options<SigninAuthSigninPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SigninAuthSigninPostResponses,
    SigninAuthSigninPostErrors,
    ThrowOnError
  >({
    url: '/auth/signin',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Forgot Password
 */
export const forgotPasswordAuthForgotPasswordPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ForgotPasswordAuthForgotPasswordPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ForgotPasswordAuthForgotPasswordPostResponses,
    ForgotPasswordAuthForgotPasswordPostErrors,
    ThrowOnError
  >({
    url: '/auth/forgot_password',
    ...options,
  })
}

/**
 * Change Password
 */
export const changePasswordAuthChangePasswordPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ChangePasswordAuthChangePasswordPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ChangePasswordAuthChangePasswordPostResponses,
    ChangePasswordAuthChangePasswordPostErrors,
    ThrowOnError
  >({
    url: '/auth/change_password',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * New User Change Password
 */
export const newUserChangePasswordAuthNewUserChangePasswordPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    NewUserChangePasswordAuthNewUserChangePasswordPostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    NewUserChangePasswordAuthNewUserChangePasswordPostResponses,
    NewUserChangePasswordAuthNewUserChangePasswordPostErrors,
    ThrowOnError
  >({
    url: '/auth/new_user_change_password',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * New Access Token
 */
export const newAccessTokenAuthNewTokenPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<NewAccessTokenAuthNewTokenPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    NewAccessTokenAuthNewTokenPostResponses,
    NewAccessTokenAuthNewTokenPostErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/auth/new_token',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Logout
 */
export const logoutAuthLogoutPost = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutAuthLogoutPostData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    LogoutAuthLogoutPostResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/auth/logout',
    ...options,
  })
}

/**
 * Create Lesson
 */
export const createLessonSetupLessonPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateLessonSetupLessonPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateLessonSetupLessonPostResponses,
    CreateLessonSetupLessonPostErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/setup/lesson',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Create Initial Lesson Plan
 */
export const createInitialLessonPlanSetupLessonPlanPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateInitialLessonPlanSetupLessonPlanPostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateInitialLessonPlanSetupLessonPlanPostResponses,
    CreateInitialLessonPlanSetupLessonPlanPostErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/setup/lesson-plan',
    ...options,
  })
}

/**
 * Create Guidance
 */
export const createGuidanceSetupGuidancePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateGuidanceSetupGuidancePostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateGuidanceSetupGuidancePostResponses,
    CreateGuidanceSetupGuidancePostErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/setup/guidance',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Delete User Lesson Plan
 */
export const deleteUserLessonPlanDeleteUserLessonPlanPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteUserLessonPlanDeleteUserLessonPlanPostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    DeleteUserLessonPlanDeleteUserLessonPlanPostResponses,
    DeleteUserLessonPlanDeleteUserLessonPlanPostErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/delete/user-lesson-plan',
    ...options,
  })
}

/**
 * Delete Lesson
 */
export const deleteLessonDeleteLessonPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteLessonDeleteLessonPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    DeleteLessonDeleteLessonPostResponses,
    DeleteLessonDeleteLessonPostErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/delete/lesson',
    ...options,
  })
}

/**
 * Delete Guidance
 */
export const deleteGuidanceDeleteGuidancePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteGuidanceDeleteGuidancePostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    DeleteGuidanceDeleteGuidancePostResponses,
    DeleteGuidanceDeleteGuidancePostErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/delete/guidance',
    ...options,
  })
}

/**
 * Delete All Guidance
 */
export const deleteAllGuidanceDeleteAllGuidancePost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<DeleteAllGuidanceDeleteAllGuidancePostData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    DeleteAllGuidanceDeleteAllGuidancePostResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/delete/all-guidance',
    ...options,
  })
}

/**
 * Ask Question
 * Ask a question to the chatbot.
 * If the user is on the mind map tab of the web application for a specific lesson, the chatbot will have access to the slide descriptions of the section that the user is currently looking at on their screen.
 * It will also have access to the user's lesson plan (mind map) if provided.
 */
export const askQuestionChatbotAskPost = <ThrowOnError extends boolean = false>(
  options: Options<AskQuestionChatbotAskPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AskQuestionChatbotAskPostResponses,
    AskQuestionChatbotAskPostErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/chatbot/ask',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Root
 */
export const rootGet = <ThrowOnError extends boolean = false>(
  options?: Options<RootGetData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    RootGetResponses,
    unknown,
    ThrowOnError
  >({
    url: '/',
    ...options,
  })
}

/**
 * Health
 */
export const healthHealthGet = <ThrowOnError extends boolean = false>(
  options?: Options<HealthHealthGetData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    HealthHealthGetResponses,
    unknown,
    ThrowOnError
  >({
    url: '/health',
    ...options,
  })
}

/**
 * Hello World
 */
export const helloWorldHelloWorldGet = <ThrowOnError extends boolean = false>(
  options?: Options<HelloWorldHelloWorldGetData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    HelloWorldHelloWorldGetResponses,
    unknown,
    ThrowOnError
  >({
    url: '/hello-world',
    ...options,
  })
}
